module.exports = "https://web-assets.ifttt.com/packs/media/pro_monthly_to_annual/desktop-28d51d38.svg";